import { gql } from "@apollo/client";

export const GET_COMMAND_PALETTE_SUGGESTIONS = gql`
  query GetCommandPaletteSuggestions($query: String!) {
    me {
      commandPaletteSuggestions(query: $query) {
        id
        title
        subtitle
        section
        apiMethod
        url
      }
    }
  }
`;
